import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-2 border-primary-300 w-16 h-16 rounded-full p-1 flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "appFont text-xl" }, "#Hashtags ;)"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Add cool tags "),
    /*#__PURE__*/_createElementVNode("span", { class: "appFont text-primary-400 bg-gray-200 dark:text-primary-300 dark:bg-gray-900 px-1 rounded-lg" }, "#😁")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HashtagIcon = _resolveComponent("HashtagIcon")!
  const _component_ItemWrap = _resolveComponent("ItemWrap")!

  return (_openBlock(), _createBlock(_component_ItemWrap, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_HashtagIcon, { class: "fa-2x" })
      ]),
      _hoisted_2
    ]),
    _: 1
  }))
}